import React from 'react'
import {Box, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../../../theme/_utils'
import MenuVerticalCard from '../MenuVerticalCard'
import {CategoryGroupColumn, getTemplateLinks, IconLinkButton, templatePropTypes} from './shared'

const MID_DESKTOP_MEDIA = '@media screen and (max-width: 1366px) and (min-width: 1200px)'

const cardsContainerProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: remCalc(20),
    minW: '0',
    flex: '0 0 auto',
    sx: {
        [MID_DESKTOP_MEDIA]: {
            flexDirection: 'column',
            maxHeight: remCalc(536),
            overflowY: 'auto',
            overflowX: 'hidden',
            overscrollBehavior: 'contain',
        },
    },
}

const midDesktopCardSize = (height) => ({
    sx: {
        [MID_DESKTOP_MEDIA]: {
            width: remCalc(619),
            minWidth: remCalc(619),
            maxWidth: remCalc(619),
            height: remCalc(height),
            minHeight: remCalc(height),
            maxHeight: remCalc(height),
        },
    },
})

export const getTemplateThreeData = (primarycategory) => {
    const baseCards =
        Array.isArray(primarycategory?.images) && primarycategory.images.length > 0
            ? primarycategory.images
            : [primarycategory?.image_1, primarycategory?.image_2].filter(Boolean)

    return {
        categoryGroup: primarycategory?.category_group ?? [],
        links: getTemplateLinks(primarycategory),
        verticalCards: baseCards.slice(0, 2),
    }
}

const TemplateThree = ({primarycategory, categoryData, locale}) => {
    const styles = useMultiStyleConfig('MenuTemplate', {variant: 'template-three'})
    const {categoryGroup, links, verticalCards} = getTemplateThreeData(primarycategory)

    const getCardWrapperStyles = (idx) => {
        if (idx === 0 && styles.firstVerticalCard) {
            return {
                ...styles.verticalCardWrapper,
                ...styles.firstVerticalCard,
                ...midDesktopCardSize(464),
            }
        }
        if (idx === 1 && styles.secondVerticalCard) {
            return {
                ...styles.verticalCardWrapper,
                ...styles.secondVerticalCard,
                ...midDesktopCardSize(827),
            }
        }
        return {...styles.verticalCardWrapper}
    }

    return (
        <Box {...styles.templateContainer} data-primarycategory-id={primarycategory?.uid}>
            <Flex {...styles.layout} alignItems="stretch" minW="0">
                <Flex
                    flexDir="column"
                    justifyContent="space-between"
                    minHeight="100%"
                    {...styles.sideColumn}
                    gap="small.base"
                >
                    <Box {...styles.listWrapper}>
                        <Flex flexDir="column" gap="xsmall.base" direction="ltr">
                            {categoryData && categoryGroup.length > 0 && (
                                <Flex flexDir="column" gap="medium.base" alignItems="flex-start">
                                    {categoryGroup.map((group) => (
                                        <CategoryGroupColumn
                                            key={group?.uid ?? group?.group_title}
                                            group={group}
                                            categoryData={categoryData}
                                            locale={locale}
                                            styles={styles}
                                            {...styles.categoryGroupColumn}
                                        />
                                    ))}
                                </Flex>
                            )}
                        </Flex>
                    </Box>

                    {links.length > 0 && (
                        <Flex flexDir="column" gap="xxsmall-1.base" alignItems="flex-start">
                            {links.map((link, idx) => (
                                <IconLinkButton
                                    key={`menu-icon-link-button-${idx}`}
                                    link={link}
                                    categoryData={categoryData}
                                    locale={locale}
                                    styles={styles}
                                />
                            ))}
                        </Flex>
                    )}
                </Flex>

                <Flex {...cardsContainerProps}>
                    {verticalCards.map((card, idx) => (
                        <Box
                            key={card?._metadata?.uid ?? `menu-vertical-card-${idx}`}
                            {...getCardWrapperStyles(idx)}
                        >
                            {card && (
                                <MenuVerticalCard
                                    card={card}
                                    categoriesData={categoryData}
                                    locale={locale}
                                />
                            )}
                        </Box>
                    ))}
                </Flex>
            </Flex>
        </Box>
    )
}

TemplateThree.propTypes = templatePropTypes

export default TemplateThree
